import React from 'react';
import './HeroSlider.css';

const HeroSlider = () => {

  const slides = [
    {
      id: 1,
      title: "Unlock the Power of the Sun!",
      subtitle: "Solar Panels for a Greener Tomorrow",
      description: "Switch to clean, renewable solar energy and save up to 90% on electricity bills. We provide premium solar systems with 3-5 years payback period and 25-year warranty guarantee.",
      video: "https://pub-24e933930fe34ffaa978daf5ee653936.r2.dev/services-hero-solar.mp4",
      buttonText: "Call Now / Free Survey",
      buttonLink: "tel:+919724820358"
    }
  ];

  const slide = slides[0]; // Get the single slide

  return (
    <section className="hero-slider">
      <div className="slider-container">
        <div className="slide active video-slide">
          <video
            className="slide-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={slide.video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="slide-overlay"></div>
          <div className="slide-content">
            <div className="container">
              <div className="slide-text">
                <h1 className="slide-title">
                  {slide.title}
                </h1>
                <p className="slide-subtitle">
                  {slide.subtitle}
                </p>
                <div className="slide-actions">
                  <a href="tel:+919724820358" className="hero-cta-btn">
                    <i className="fas fa-bolt"></i>
                    Buy SolarSystem
                  </a>
                  <a href="/contact" className="hero-secondary-btn">
                    <i className="fas fa-circle"></i>
                    Get more info
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Shapes */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
      </div>

    </section>
  );
};

export default HeroSlider;